import { useState } from 'react';
import { faqList } from '@/mocks/nav';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full max-w-content mx-auto px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="font-label text-xs tracking-[0.28em] text-secondary-600">FAQ</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              关于入口与地址
              <br />
              你可能想问
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              收录的是访问过程中最常被问到的问题，如果还有疑问，可以在上方的反馈区告诉我们。
            </p>
            <a
              href="#community"
              className="mt-6 inline-flex items-center gap-2 text-sm font-label text-primary-600 hover:text-primary-700 cursor-pointer"
            >
              前往反馈区留言
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-lg bg-background-50 border border-background-200/70 divide-y divide-background-200/70 overflow-hidden">
              {faqList.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="w-full flex items-start gap-4 px-5 md:px-7 py-5 text-left cursor-pointer"
                    >
                      <span className="font-heading text-sm text-primary-600 mt-0.5">
                        {String(index + 1).padStart(2, '0')}
                      </span>
                      <span className="flex-1 font-heading text-base md:text-lg font-bold text-foreground-950">
                        {item.q}
                      </span>
                      <span
                        className={`w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-transform ${
                          isOpen ? 'rotate-45' : ''
                        }`}
                      >
                        <i className="ri-add-line"></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 md:px-7 pb-6 pl-14 md:pl-[4.75rem]">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}